import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { cart } from '@/theme/Cart';
import { formatMoney } from '@/utils/formatting';

@Component
export class FreeDeliveryMessage extends ThemeComponent {
    @Prop threshold!: number;
    @Prop doesNotQualifyMessage!: string;
    @Prop qualifiesMessage!: string;
    @Prop cartamount!: number;

    @Ref doesNotQualifyMessageContainer!: HTMLElement;
    @Ref qualifiesMessageContainer!: HTMLElement;
    @Ref remainingSpend!: HTMLElement;

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            const cartTotal = this.cartamount;
            this.updateShippingInfo(cartTotal);
        });

        document.addEventListener('cartChanged', () => {
            const cartTotal = cart.totalPrice;
            this.updateShippingInfo(cartTotal);
        });

        document.addEventListener('cartClosed', () => {
            const cartTotal = cart.totalPrice;
            this.updateShippingInfo(cartTotal);
        });
    }

    updateShippingInfo(cartTotal:number) {
        // Check if cart toal price is greater than threshold
        if (cartTotal >= this.threshold) {

            // Show qualifies message
            this.qualifiesMessageContainer.classList.remove('free-delivery-message__qualifies-message--hidden');
            // eslint-disable-next-line max-len
            this.doesNotQualifyMessageContainer.classList.add('free-delivery-message__does-not-qualify-message--hidden');
        } else {

            const remainingSpend = this.threshold - cartTotal;

            // Update message HTML
            this.remainingSpend.innerHTML = formatMoney(remainingSpend) as string;

            // Show does not qualify message
            // eslint-disable-next-line max-len
            this.doesNotQualifyMessageContainer.classList.remove('free-delivery-message__does-not-qualify-message--hidden');
            this.qualifiesMessageContainer.classList.add('free-delivery-message__qualifies-message--hidden');
        }
    }
}
